import axios from 'axios';

export function getCostEstimateLogs(id, filteredView) {
    const route = '/cost-estimates/{id}/history/' + filteredView;
    return axios.get(route.replace('{id}', id));
}

export default {
    getCostEstimateLogs
}
